import React from 'react';

const Tab = (props) => {
    const { tabData, isActive, onTabSelectHandler, idx } = props;

    return (
        <li role="tab" className="grid-col-6 gi-tab__item">
            <button className={isActive ? 'active' : ''}
                id={`tab-${idx}`}
                onClick={onTabSelectHandler}
                data-automation-id={`tab-${tabData.applicationYear}`}
                aria-selected={isActive ? 'true' : 'false'}
                aria-controls={`tabpanel_${tabData.applicationYear}`}>
                {tabData.applicationYear}
            </button>
        </li>
    );
};

export default Tab;
